import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { UpdateCapitalNeedMutation, UpdateCapitalNeedInput } from '#/graphql/types';
import { updateCapitalNeed } from '#/graphql/mutations';
import { get } from 'lodash';
import { GET_CAPITAL_NEED } from './useCapitalNeedQuery';

const q = gql(updateCapitalNeed);

const useCapitalNeedUpdate = () => {
  const [mutation, result] = useMutation<UpdateCapitalNeedMutation>(q);
  const updateCapitalNeed = useCallback(
    async (id: string, data: UpdateCapitalNeedInput) => {
      const response = await mutation({
        variables: {
          id,
          data,
        },
        refetchQueries: [{ query: GET_CAPITAL_NEED, variables: { id } }],
        awaitRefetchQueries: true,
      });

      const result = get(response, 'data.updateCapitalNeed', undefined);

      if (result && result.status !== 200) {
        const errorMessage = result.errors?.join('\n') || 'Update failed';
        throw new Error(errorMessage);
      }

      return get(result, 'data', undefined);
    },
    [mutation],
  );

  return { updateCapitalNeed, result };
};

export default useCapitalNeedUpdate;
